import { LanguageSpecificationResponseItem } from "../../../common/api/orders-api/language-specification/responses/GetLanguageSpecificationsListResponse";

export interface LanguageSpecificationListingItem {
    id: string;
    name: string;
    updatedDate: string;
}

export const mapToLanguageSpecificationListingItem = (
    response: LanguageSpecificationResponseItem
): LanguageSpecificationListingItem => ({
    id: response.id,
    name: response.name,
    updatedDate: response.audit.updatedDate
});
